import { Review, TripsPageQuery } from '@website/types/graphqlOperations';
import { Col, Row } from 'react-bootstrap';
import { BsReply } from 'react-icons/bs';

type Props = {
  review: Pick<Review, 'id' | 'reply'>;
  host: Pick<TripsPageQuery['tripByURL']['host'], 'id' | 'name'>;
};

export default function ShowReply({ review, host }: Props) {
  if (!review?.reply) {
    return null;
  }

  return (
    <Row>
      <Col
        xs={12}
        style={{
          paddingLeft: '2rem',
          paddingTop: '1rem',
        }}
      >
        <div
          className="p-2 rounded"
          style={{
            backgroundColor: '#EFEFEF',
          }}
        >
          <Row>
            <Col xs={'auto'} className="text-center">
              <BsReply
                style={{
                  transform: 'scaleX(-1) scaleY(-1)',
                }}
                size={18}
              />
            </Col>
            <Col>
              <div className="fw-bold text-sm text-muted ">
                Reply by {host.name}:
              </div>
              <div
                className="text-muted text-sm py-1"
                style={{
                  whiteSpace: 'pre-wrap',
                }}
              >
                {review.reply.content}
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
}
